import {type RefObject, useCallback, useState} from 'react';
import {useTextAnalyzeStep} from '../../../../../core/repositories/mypageEntryManagementsRepository';
import {ENTRY_SOURCE_TYPE_TEXT_ANALYSIS} from '../../../constants/entrySourceTypes';
import {
  buildAnalyzeStepParams,
  showAnalyzeError,
} from '../../../usecase/analyzeStepHelpers';
import {TextImportModal} from '../Presenter/Progress/TextImportModal';
import type {StepCandidatePreviewModalRef} from './StepCandidatePreviewModalContainer';

type Props = {
  opened: boolean;
  onClose: () => void;
  stepCandidatePreviewModalRef?: RefObject<StepCandidatePreviewModalRef>;
  companyId?: number;
  entryManagementId?: number;
  onSuccess?: () => void;
  onBack?: () => void;
};

export const TextImportModalContainer: React.FC<Props> = ({
  opened,
  onClose,
  stepCandidatePreviewModalRef,
  companyId,
  entryManagementId,
  onSuccess,
  onBack,
}) => {
  const [text, setText] = useState('');
  const textAnalyzeStepMutation = useTextAnalyzeStep();

  const resetState = useCallback(() => {
    setText('');
  }, []);

  const handleClose = useCallback(() => {
    resetState();
    onClose();
    onBack?.();
  }, [resetState, onClose, onBack]);

  const handleSuccess = useCallback(() => {
    resetState();
    onClose();
    onSuccess?.();
  }, [resetState, onClose, onSuccess]);

  const handleSubmit = async () => {
    if (!text.trim()) {
      return;
    }

    try {
      const result = await textAnalyzeStepMutation.mutateAsync({
        text,
        ...buildAnalyzeStepParams(companyId, entryManagementId),
      });

      if (!result.ok) {
        showAnalyzeError('テキスト');
        return;
      }

      // テキストインポートモーダルを閉じる
      handleSuccess();

      // テキスト解析結果をプレビューモーダルに渡す
      if (stepCandidatePreviewModalRef?.current) {
        stepCandidatePreviewModalRef.current.open(
          result.value,
          ENTRY_SOURCE_TYPE_TEXT_ANALYSIS,
        );
      }
    } catch (error) {
      showAnalyzeError('テキスト', error);
    }
  };

  return (
    <TextImportModal
      opened={opened}
      onClose={handleClose}
      onSubmit={handleSubmit}
      text={text}
      onChange={setText}
      isLoading={textAnalyzeStepMutation.isLoading}
    />
  );
};
